import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { transformFixtureListResponse } from "~pages/Fixtures/utilities";
import { useApi } from "~shared/api";

export const getFixtureListQueryKey = ({
  sport,
  organizationId,
  seasonId,
}: {
  sport: string;
  organizationId: string;
  seasonId: string;
}) => ["fixtureListPage", sport, organizationId, seasonId];

export const useFetchAllSeasonFixtures = () => {
  const { fetchData } = useApi();
  const { organizationId = "", sport = "", seasonId = "" } = useParams();

  const fn = async () => {
    const response = await fetchData({
      url: `${sport}/o/${organizationId}/seasons/${seasonId}/fixtures/all`,
    });
    return transformFixtureListResponse(response);
  };

  return useQuery({
    queryKey: getFixtureListQueryKey({ sport, organizationId, seasonId }),
    queryFn: async () => await fn(),
  });
};
